export enum FinanceTypeEnum {
  FINANCE_CALCULATOR = 'finance_calculator',
  FINANCE_EXPRESS = 'finance_express'
}
